// SyncBadge — malý info text o poslednom syncu z externého systému
// Použitie: <SyncBadge source="mksoft" />
import React, { useEffect, useState } from 'react'
import { COLORS, TYPO, SPACE } from '../theme.js'
import { fetchAuth } from '../auth/fetchAuth.js'

let _cache = null
let _promise = null
function load() {
  if (_cache) return Promise.resolve(_cache)
  if (!_promise) {
    _promise = fetchAuth('/api/sync/info')
      .then(r => r.ok ? r.json() : null)
      .then(d => { _cache = d || {}; return _cache })
      .catch(() => ({}))
  }
  return _promise
}

const LABELS = {
  mksoft: 'MKsoft',
}

function fmtKedy(s) {
  if (!s) return '—'
  const d = new Date(s.replace(' ', 'T'))
  if (isNaN(d)) return s
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const yy = d.getFullYear()
  const hh = String(d.getHours()).padStart(2, '0')
  const mi = String(d.getMinutes()).padStart(2, '0')
  return `${dd}.${mm}.${yy} ${hh}:${mi}`
}

export function SyncBadge({ source = 'mksoft', prefix = 'Posledný sync z' }) {
  const [info, setInfo] = useState(_cache?.[source])
  useEffect(() => {
    if (!_cache) load().then(d => setInfo(d?.[source]))
  }, [source])
  if (!info || !info.synced_at) {
    return (
      <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic' }}>
        {prefix} {LABELS[source] || source}: zatiaľ nesynchronizované
      </span>
    )
  }
  return (
    <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontStyle: 'italic' }}>
      {prefix} {LABELS[source] || source}: {fmtKedy(info.synced_at)}
      {typeof info.imported === 'number' && info.imported > 0 && (
        <span style={{ marginLeft: 6 }}>· {info.imported} dokladov</span>
      )}
    </span>
  )
}

export default SyncBadge
